// extracted by mini-css-extract-plugin
export var articleBox = "styles-module--articleBox--3iGUp";
export var articleBoxDark = "styles-module--articleBoxDark--2CzLV";